var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_313",
    "data-name": "Group 313",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.071,
    height: 22.25,
    viewBox: "0 0 22.071 22.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 22.071,
    height: 22.25,
    fill: "#60a6db"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M18.547,13.762a.964.964,0,0,0-.96-.819H9.8L8.389,11.269a1.6,1.6,0,0,0-1.2-.573H2.13a1.235,1.235,0,0,0-.936.445,1.26,1.26,0,0,0-.271,1.011l.134.791H.969a.957.957,0,0,0-.957,1.1l1.57,10.187A1.257,1.257,0,0,0,2.824,25.3h16.3a.971.971,0,0,0,.734-.337.961.961,0,0,0,.225-.772Z",
    transform: "translate(0 -3.048)",
    fill: "#60a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M17.789,4.351H11.7a.8.8,0,0,0,0,1.6h6.088a.8.8,0,0,0,0-1.6",
    transform: "translate(-3.118 -1.24)",
    fill: "#60a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M29.583,12.054a.936.936,0,0,0-.7-.332H27.154l.393,3.643.939,6.364L29.8,12.8a.944.944,0,0,0-.217-.744",
    transform: "translate(-7.739 -3.341)",
    fill: "#60a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M8.261,1.469H18.889V8.684h1.47V.935A.945.945,0,0,0,19.419,0H7.665a1.011,1.011,0,0,0-1,1.025V6.61h1.6Z",
    transform: "translate(-1.899 0)",
    fill: "#60a6db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M17.8,8.46H11.708a.788.788,0,0,0-.744.643,2.619,2.619,0,0,1,1.352.835l.111.12H17.8a.8.8,0,0,0,0-1.6",
    transform: "translate(-3.125 -2.411)",
    fill: "#60a6db"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.f48dff7a6b567e1b9b4832036f454cd7.svg";
export { ForwardRef as ReactComponent };